export const alphabetRegex = /^[aA-zZ\s]+$/;
